// angular import
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AdBackButtonComponent } from 'src/app/admin/ad-admin/ad-back-button/ad-back-button.component';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule, AdBackButtonComponent],
  declarations: [BreadcrumbComponent],
  exports: [BreadcrumbComponent]
})
export class BreadcrumbModule {}
